// Polyfill for older-browsers (It's necessary for android kitkat chrome).
import 'core-js/es/map';
import 'core-js/es/set';
import 'raf/polyfill';
import "core-js/stable";
import "regenerator-runtime/runtime";

import React from 'react';
import ReactDOM from 'react-dom';
import App from './js/App';
import configureHotKeys from './hotkeys';
import * as serviceWorker from './serviceWorker';

configureHotKeys();

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.register();
